import type { ReportTable } from '@record-fill';

export interface ExportColumn {
  key: string;
  header: string;
}

export interface ExportSheet {
  columns: ExportColumn[];
  rows: Array<Record<string, string>>;
}

// A generated "(2)" suffix can collide with a label that already ends in "(2)", so every
// name handed out is reserved and the suffix grows until the name is free.
export function uniqueHeaders(labels: string[]): string[] {
  const taken = new Set<string>();
  return labels.map((label) => {
    let header = label;
    let suffix = 2;
    while (taken.has(header)) {
      header = `${label} (${suffix})`;
      suffix += 1;
    }
    taken.add(header);
    return header;
  });
}

export function buildExportSheet(table: ReportTable): ExportSheet {
  const headers = uniqueHeaders(table.columns.map((column) => column.label));
  const columns = table.columns.map((column, index) => ({ key: column.key, header: headers[index] }));
  const rows = table.rows.map((row) => Object.fromEntries(columns.map((column, index) => [column.key, row[index] ?? ''])));
  return { columns, rows };
}
